<template>
  <!-- 2024.10.28 kouta.noborisaka 三井化学（市原工場）:ウィンドウ幅に応じて横スクロールを表示 -->
  <div style="overflow-x: auto">
    <!-- 2024.10.29 kouta.noborisaka 三井化学（市原工場）:最小幅を設定 -->
    <v-container style="min-width: 1000px">
      <v-container class="noPaddingBtm">
        <v-card flat>
          <v-row>
            <v-col cols="5" class="headerTitle headerGroup noPaddingBtm">
              <v-row>
                <v-col class="noPaddingBtm" :cols="4">
                  <ryou-select
                    class="ryouSelectStyle"
                    :label="'物件グループ名'"
                    :items="dynamicItems"
                    :itemText="'build_group_name'"
                    :itemValue="'build_group_id'"
                    v-model="selectOptionValue"
                    :value="selectOptionValue"
                  >
                  </ryou-select>
                </v-col>
                <v-col class="noPaddingBtm" :cols="4">
                  <ryou-select
                    class="ryouSelectStyle"
                    :label="'物件名'"
                    :items="buildingItems"
                    :itemText="'building_name'"
                    :itemValue="'building_id'"
                    v-model="selectBuildingValue"
                    :value="selectBuildingValue"
                  >
                  </ryou-select>
                </v-col>
                <v-col class="noPaddingBtm" :cols="4">
                  <ryou-autocomplete
                    class="ryouSelectStyle"
                    :label="'利用者'"
                    :items="userItems"
                    :itemText="'user_name'"
                    :itemValue="'user_id'"
                    v-model="selectUserValue"
                    :value="selectUserValue"
                  >
                  </ryou-autocomplete>
                </v-col>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="5">
              <v-row class="justify-end">
                <v-col cols="4" class="noPadding">
                  <ryou-date-format
                    class="ryouSelectStyle"
                    v-model="eatDate1"
                    :value="eatDate1"
                    :label="'出力期間'"
                    :type="'date'"
                    :format="'$1/$2/$3'"
                    :min="FutureeatDate1"
                    :max="getFutureeatDate1"
                    :rules="dateRules"
                  >
                  </ryou-date-format>
                </v-col>

                <v-col cols="4" class="noPadding">
                  <ryou-date-format
                    class="ryouSelectStyle"
                    v-model="eatDate2"
                    :value="eatDate2"
                    :label="'出力期間'"
                    :type="'date'"
                    :format="'$1/$2/$3'"
                    :min="selectMin"
                    :max="getFutureDay()"
                    :rules="dateRules"
                  >
                  </ryou-date-format>
                </v-col>
                <v-col cols="4" class="noPadding">
                  <ryou-black-btn
                    label="食事確認出力"
                    :handlerClick="pdfFileDownLoad"
                    :iconCls="'mdi-file-download'"
                    :disabled="btnCtrl"
                  >
                  </ryou-black-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <v-container>
        <v-row>
          <v-col>
            <v-sheet height="64" style="margin-left: 43%">
              <v-toolbar flat>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="calendarPrv"
                  :disabled="arrowCtrlFlag"
                >
                  <v-icon x-large> mdi-chevron-left </v-icon>
                </v-btn>
                <v-toolbar-title>
                  <h2>{{ this.canderTitle }}</h2>
                </v-toolbar-title>
                <v-btn
                  fab
                  text
                  small
                  color="grey darken-2"
                  @click="calendarNext"
                  :disabled="arrowCtrlFlag"
                >
                  <v-icon x-large> mdi-chevron-right </v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-sheet>
            <!-- 2024.10.29 kouta.noborisaka 三井化学（市原工場）:高さ指定「height="600"」を削除 -->
            <v-sheet>
              <!-- 2024.10.29 kouta.noborisaka 三井化学（市原工場）:メニューが複数個ある際に省略表示しないように「:event-more="false"」を追加 -->
              <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="events"
                :event-more="false"
                :type="type"
                locale="ja-jp"
                @click:event="showEvent"
                @click:date="btnClick($event)"
              >
                <template v-slot:day="props">
                  <template v-for="(ent, index) in notOfferEventsDateList">
                    <div
                      :key="index"
                      class="disable"
                      v-if="ent == props.date"
                      style="text-align: center"
                    >
                      提供無し
                    </div>
                  </template>
                </template>
                <template v-slot:event="{ event }">
                  <v-row>
                    <!-- 2024.10.29 kouta.noborisaka 三井化学（市原工場）:styleに「white-space: normal」を追加 -->
                    <v-col
                      style="
                        text-align: center;
                        color: black;
                        font-size: 18px;
                        white-space: normal;
                      "
                    >
                      {{ event.name }}
                    </v-col>
                    <v-col
                      style="text-align: center; color: black; font-size: 18px"
                    >
                      {{ event.count }}
                    </v-col>
                  </v-row>
                </template>
              </v-calendar>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-card class="mx-auto my-n3">
          <v-row no-gutters>
            <v-col cols="1">
              <v-row no-gutters justify="center">
                <v-col cols="12">
                  <v-card outlined tile color="blue lighten-3">
                    <v-card-text class="text-center pa-1 body-2 black--text"
                      >区分</v-card-text
                    >
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card outlined tile color="blue lighten-4">
                    <v-card-text class="text-center pa-1 body-2 black--text"
                      >合計</v-card-text
                    >
                  </v-card>
                </v-col>
                <v-col cols="12" v-if="$useWithoutEat">
                  <v-card outlined tile color="blue lighten-3">
                    <v-card-text class="text-center pa-1 body-2 black--text"
                      >喫食数</v-card-text
                    >
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card outlined tile color="blue lighten-4">
                    <v-card-text class="text-center pa-1 body-2 black--text"
                      >喫食率</v-card-text
                    >
                  </v-card>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              cols="1"
              v-for="(item, index) in mealReserveSum"
              :key="index"
            >
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card outlined tile>
                    <v-card-text class="text-center pa-1 body-2 black--text">{{
                      item.mealName
                    }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card outlined tile>
                    <v-card-text class="text-center pa-1 body-2 black--text">{{
                      item.reserveCount
                    }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" v-if="$useWithoutEat">
                  <v-card outlined tile>
                    <v-card-text class="text-center pa-1 body-2 black--text">{{
                      item.eatCount
                    }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card outlined tile>
                    <v-card-text class="text-center pa-1 body-2 black--text"
                      >{{ item.rate }}%</v-card-text
                    >
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <MealReservationConfirmationDayDialog
        ref="reservationConfirmationDialog"
        @reCalendar="calendarGet"
      >
      </MealReservationConfirmationDayDialog>
    </v-container>
  </div>
</template>

<script>
import RyouSelect from "../../components/formInput/RyouSelect";
import RyouAutocomplete from "../../components/formInput/RyouAutocomplete";
import MealReservationConfirmationDayDialog from "./modules/MealReservationConfirmationDayDialog.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import fileDownload from "js-file-download";

export default {
  name: "MealReservationConfirmation",
  components: {
    RyouSelect,
    RyouAutocomplete,
    MealReservationConfirmationDayDialog,
    RyouDateFormat,
    RyouBlackBtn,
  },
  data() {
    return {
      buildingChangeFlg: false,
      p2Form: true,
      focus: "",
      btnCtrl: false,
      type: "month",
      canderTitle: "", //カレンダーのヘッダ
      hasEventsDateList: [], //メニューが存在する日付["YYYY-MM-dd","YYYY-MM-dd",...]
      hasEventsDateDetailedDataList: [], //メニューが存在する詳細データ
      mealNames: [], //日付の食事名[食事一,食事二,...]
      events: [], //メニューが存在毎日のイベント[ある日の食事一,食事二,...]
      notOfferEventsDateList: [], //提供無し日付["YYYY-MM-dd","YYYY-MM-dd",...]
      notOfferEventsDateDetailedDataList: [], //提供無し日付詳細データ
      selectOptionValue: "",
      selectBuildingValue: "",
      selectUserValue: "",
      dynamicItems: [],
      buildingItems: [],
      userItems: [],
      eatDate1: "",
      eatDate2: "",
      eatDate3: "",
      dateRules: [],
      selectMin: "",
      FutureeatDate1: "",
      getFutureeatDate1: "",
      nowDate1: "",
      nowDate2: "",
      nowDate3: "",
      nowDate4: "",
      eatDateStr: "",
      eatDateEnd: "",
      date1: "",
      maxEatDate: "",
      target: "",
      dateBetweenRules: [],
      mealReserveSum: [], //[{mealName:"",reserveSum:0,eatSum:0}],
      //colors: [
      //  "#FF9800",//オレンジ
      //  "#673AB7",//深紫
      //  "#4CAF50",//緑
      //  "#E91E63",//ピンク
      //  "#3F51B5",//インディゴ
      //  "#009688",//teal
      //  "#FF5722",//深オレンジ
      //  "#8BC34A",//light-green
      //  "#D32F2F",//red darken-2
      //  "#1565C0"//blue darken-3
      //],
      colors: [
        "#FFEBCC", //オレンジ
        "#A093B8", //深紫
        "#8DB08E", //緑
        "#E8BAC9", //ピンク
        "#9196B5", //インディゴ
        "#789693", //teal
        "#FFD8CC", //深オレンジ
        "#B0C29B", //light-green
        "#D4A9A9", //red darken-2
        "#99ABBF", //blue darken-3
      ],
      arrowCtrlFlag: false,
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
    this.dateRules.push(this.GlobalRules.required);

    /*this.StrtDateSet();*/
  },
  watch: {
    selectOptionValue(value) {
      if (this.selectBuildingValue != "") {
        this.buildingChangeFlg = true;
        this.selectBuildingValue = "";
      }

      this.selectUserValue = "";
      this.userItems = [];

      //if (value != "") {
      if (value) {
        let params = {
          buildGroupId: value,
        };
        //物件一覧を取得
        if (params.buildGroupId != "") {
          this.getRequest(
            "/mealReservationConfirmation/buildingGet",
            params,
            this.$store.getters.getUserToken
          ).then((data) => {
            if (data.success) {
              var mapDatas = data.result.map((item) => {
                item.building_id = String(item.building_id);
                return item;
              });
              this.buildingItems = mapDatas;
              this.selectBuildingValue = mapDatas[0].building_id;
              // this.buildingItems.push(this.selectBuildingValue);
            }
          });
        }

        //物件選択が空の場合はグループに紐づくユーザを取得する
        // if (this.selectBuildingValue == "") {
        if (params.buildGroupId != "") {
          //selectBoxで値を取る
          this.getRequest(
            "/MealReservationConfirmation/reserveUserGet",
            params,
            this.$store.getters.getUserToken
          ).then((data) => {
            if (data.success && data.status == "200") {
              this.reserveUserSelectCtrl = false;
              var mapDatas = data.result.map((item) => {
                item.user_name = item.user_id + "　" + item.user_name;
                return item;
              });
              this.userItems = mapDatas;
            }
          });
        }

        if (!this.buildingChangeFlg) {
          // 2024.11.07 kouta.noborisaka 三井化学（市原工場）:selectBuildingValueのcalendarGetの呼び出しと非同期で動き、画面下部の表が２になる可能性があるためコメントアウト
          // this.calendarGet();
        } else {
          this.buildingChangeFlg = false;
        }
      }
    },
    selectBuildingValue(value) {
      this.selectUserValue = "";

      let params;
      //物件が選択されている場合は物件で検索
      if (value != "" && value != null) {
        params = {
          buildGroupId: this.selectOptionValue,
          buildingId: value,
        };
      } else {
        //物件が選択されていない場合はグループで検索
        params = {
          buildGroupId: this.selectOptionValue,
        };
      }

      this.getRequest(
        "/MealReservationConfirmation/reserveUserGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success && data.status == "200") {
          this.reserveUserSelectCtrl = false;
          var mapDatas = data.result.map((item) => {
            item.user_name = item.user_id + "　" + item.user_name;
            return item;
          });
          this.userItems = mapDatas;
        }
      });

      this.calendarGet();
    },
    canderTitle() {
      if (this.selectOptionValue != "") {
        this.calendarGet();
      }
    },
    selectUserValue(value) {
      if (value != "") {
        this.calendarGet();
      }
    },
    eatDate1(value) {
      if (value != null && value != "") {
        this.selectMin = value;
      } else {
        this.selectMin = this.nowDate1;
      }
    },
    eatDate2(value) {
      if (value != null && value != "") {
        this.getFutureeatDate1 = value;
        var date2 = new Date(Date.parse(value));
        date2.setDate(date2.getDate() - 30);
        this.FutureeatDate1 =
          date2.getFullYear() +
          "-" +
          (date2.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          date2.getDate().toString().padStart(2, "0");
      } else {
        this.getFutureeatDate1 = this.nowDate2;
        this.FutureeatDate1 = "";
      }
    },
  },
  methods: {
    //日付をクリック
    btnClick(date) {
      this.canderTitle = date.year + "年" + date.month + "月";
      let getNowMonth = this.$refs.calendar.title.split("月 ");

      // 当月かどうかを判断
      if (date.month == getNowMonth[0]) {
        if (this.selectOptionValue != null && this.selectOptionValue != "") {
          let DialogData = this.calendarDialogDataGet(date.date);

          if (DialogData) {
            // パラメータ1:ダイアログ日付、パラメータ2:物件グループID、パラメータ3:日付の食事名 パラメータ4:物件ID
            this.$refs.reservationConfirmationDialog.getInputValue(
              date.date,
              this.selectOptionValue,
              this.mealNames,
              this.selectBuildingValue,
              this.selectUserValue
            );
            for (var i = 0; i < this.buildingItems.length; i++) {
              if (
                this.buildingItems[i].building_id == this.selectBuildingValue
              ) {
                this.$refs.reservationConfirmationDialog.setBuildingName(
                  this.buildingItems[i].building_name
                );
              }
            }
          }
        }
      }
    },
    //イベントクリック
    showEvent(event) {
      if (this.selectOptionValue != null && this.selectOptionValue != "") {
        let DialogData = this.calendarDialogDataGet(event.day.date);

        if (DialogData) {
          // パラメータ1:ダイアログ日付、パラメータ2:物件グループID、パラメータ3:日付の食事名 パラメータ4:物件ID
          this.$refs.reservationConfirmationDialog.getInputValue(
            event.day.date,
            this.selectOptionValue,
            this.mealNames,
            this.selectBuildingValue,
            this.selectUserValue
          );
          for (var i = 0; i < this.buildingItems.length; i++) {
            if (this.buildingItems[i].building_id == this.selectBuildingValue) {
              this.$refs.reservationConfirmationDialog.setBuildingName(
                this.buildingItems[i].building_name
              );
            }
          }
        }
      }
    },
    initData() {
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      //selectBoxで値を取る
      this.getRequest(
        "/mealReservationConfirmation/buildGroupGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.dynamicItems = data.result;
          // 物件グループの初期値セット
          this.selectOptionValue = this.$store.getters.getBuilGroupId;
        }
      });
    },
    //カレンダーデータ取得
    calendarGet() {
      // データクリア
      this.mealReserveSum = [];
      this.mealNames = [];
      this.events = [];
      this.hasEventsDateList = [];
      this.hasEventsDateDetailedDataList = [];
      this.notOfferEventsDateList = [];
      this.notOfferEventsDateDetailedDataList = [];
      this.$(".v-calendar-weekly__day:has(div.disable)").removeClass("mask");
      this.$("div.disable").remove();

      if (this.selectOptionValue != null && this.selectOptionValue != "") {
        var that = this;

        let mealClassParams = {
          buildGroupId: this.selectOptionValue,
        };

        this.getRequest(
          "/mealReservationConfirmation/mealClassGet",
          mealClassParams,
          this.$store.getters.getUserToken
        ).then((data) => {
          // 食事区分取得
          if (data.success) {
            that.mealNames = data.result;
            for (var meal in that.mealNames) {
              this.mealReserveSum.push({
                mealName: that.mealNames[meal].meal_name,
                reserveCount: 0,
                eatCount: 0,
                tenantCount: 0,
                rate: 0,
              });
            }
          }
        });

        //年月取得
        let titleYear = this.canderTitle.split("年");
        let titleMonth = titleYear[1].split("月");
        if (this.selectBuildingValue == "") {
          return;
        }
        let calendarParams = {
          userId: this.selectUserValue,
          buildGroupId: this.selectOptionValue,
          buildingId: this.selectBuildingValue,
          currentYM: titleYear[0] + "-" + titleMonth[0],
        };

        this.arrowCtrlFlag = true;

        this.getRequest(
          "/mealReservationConfirmation/calendarReservationConfirmationGet",
          calendarParams,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success) {
            // 現在の月を循環
            for (
              let dateIndex = 0;
              dateIndex < data.result.length;
              dateIndex++
            ) {
              //取得当日
              let dateItem = data.result[dateIndex];
              // 取得当日(Key,Value)
              for (let dateKey in dateItem) {
                //取得当日データ
                let dateData = dateItem[dateKey];

                // 取得当日データあり
                if (dateData.length != 0) {
                  // データが存在する日付
                  if (dateData[0].offer_flg == "1") {
                    //食事提供あり結果セット
                    if (that.hasEventsDateList.indexOf(dateKey) < 0) {
                      that.hasEventsDateList.push(dateKey);
                      that.hasEventsDateDetailedDataList.push(dateItem);
                    }
                  } else if (dateData[0].offer_flg == "0") {
                    //食事提供なし結果セット
                    if (that.notOfferEventsDateList.indexOf(dateKey) < 0) {
                      that.notOfferEventsDateList.push(dateKey);
                      that.notOfferEventsDateDetailedDataList.push(dateItem);
                    }
                  }
                }
              }
            }
            this.getValue();
          }
          this.arrowCtrlFlag = false;
        });
      }
    },
    //カレンダー、ポップアップ、データ取得
    calendarDialogDataGet(value) {
      for (
        let hedddIndex = 0;
        hedddIndex < this.hasEventsDateDetailedDataList.length;
        hedddIndex++
      ) {
        let hedddItem = this.hasEventsDateDetailedDataList[hedddIndex];

        for (let hedddKey in hedddItem) {
          if (hedddKey == value) {
            return hedddItem;
          }
        }
      }
    },
    //カレンダーヘッドの初期化時間
    initCanderValue(tilte) {
      let titleList = tilte.split("月 ");
      let newTitile = titleList[1] + "年" + titleList[0] + "月";

      return newTitile;
    },
    //カレンダーの来月
    calendarNext() {
      this.$refs.calendar.next();

      setTimeout(() => {
        this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
      }, 100);

      this.getValue();
    },
    //カレンダーの前の月
    calendarPrv() {
      this.$refs.calendar.prev();

      setTimeout(() => {
        this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
      }, 100);

      this.getValue();
    },
    //カレンダーデータのロードが完了しました。
    getValue() {
      // データが存在する日食、事区分表示
      for (
        let hedddlIndex = 0;
        hedddlIndex < this.hasEventsDateDetailedDataList.length;
        hedddlIndex++
      ) {
        let eachDayDetailedData =
          this.hasEventsDateDetailedDataList[hedddlIndex];

        for (let eachDayDetailedDatakey in eachDayDetailedData) {
          //当日の食事は区分表示
          for (
            let mealClassIndex = 0;
            mealClassIndex < this.mealNames.length;
            mealClassIndex++
          ) {
            let edddIndex = 0;

            for (
              edddIndex = 0;
              edddIndex < eachDayDetailedData[eachDayDetailedDatakey].length;
              edddIndex++
            ) {
              if (
                this.mealNames[mealClassIndex].meal_class ==
                eachDayDetailedData[eachDayDetailedDatakey][edddIndex]
                  .meal_class
              ) {
                this.events.push({
                  name: this.mealNames[mealClassIndex].meal_name,
                  start: eachDayDetailedDatakey,
                  color: this.colors[mealClassIndex],
                  timed: false,
                  count:
                    this.$getUseWithoutEat() == true
                      ? parseInt(
                          eachDayDetailedData[eachDayDetailedDatakey][edddIndex]
                            .without_eat_flg_count
                        ) +
                        "/" +
                        (parseInt(
                          eachDayDetailedData[eachDayDetailedDatakey][edddIndex]
                            .reserve_flg_count
                        ) +
                          parseInt(
                            eachDayDetailedData[eachDayDetailedDatakey][
                              edddIndex
                            ].additional_num_count
                          ))
                      : parseInt(
                          eachDayDetailedData[eachDayDetailedDatakey][edddIndex]
                            .reserve_flg_count
                        ),
                });

                this.mealReserveSum[mealClassIndex].reserveCount += parseInt(
                  eachDayDetailedData[eachDayDetailedDatakey][edddIndex]
                    .reserve_flg_count
                );
                this.mealReserveSum[mealClassIndex].reserveCount += parseInt(
                  eachDayDetailedData[eachDayDetailedDatakey][edddIndex]
                    .additional_num_count
                );
                this.mealReserveSum[mealClassIndex].eatCount += parseInt(
                  eachDayDetailedData[eachDayDetailedDatakey][edddIndex]
                    .without_eat_flg_count
                );

                this.mealReserveSum[mealClassIndex].tenantCount += parseInt(
                  eachDayDetailedData[eachDayDetailedDatakey][edddIndex]
                    .tenant_num
                );

                break;
              }
            }

            this.mealReserveSum[mealClassIndex].rate =
              Math.round(
                (this.mealReserveSum[mealClassIndex].reserveCount /
                  this.mealReserveSum[mealClassIndex].tenantCount) *
                  100 *
                  100
              ) / 100;

            if (
              edddIndex == eachDayDetailedData[eachDayDetailedDatakey].length
            ) {
              this.events.push({
                name: this.mealNames[mealClassIndex].meal_name,
                start: eachDayDetailedDatakey,
                color: this.colors[mealClassIndex],
                timed: false,
                count: "0",
              });
            }
          }
        }
      }
      setTimeout(() => {
        // disableを含む要素を見つけて、スタイルを追加します
        this.$(".v-calendar-weekly__day:has(div.disable)").addClass("mask");
      }, 100);
    },
    pdfFileDownLoad() {
      const date1 = new Date();
      this.nowDate =
        date1.getFullYear() +
        (date1.getMonth() + 1).toString().padStart(2, "0") +
        date1.getDate().toString().padStart(2, "0") +
        date1.getHours().toString().padStart(2, "0") +
        date1.getMinutes().toString().padStart(2, "0") +
        date1.getSeconds().toString().padStart(2, "0");

      let pdfParams = {
        buildGroupId: this.selectOptionValue,
        buildingId: this.selectBuildingValue,
        otputPeriodDate1: this.eatDate1,
        otputPeriodDate2: this.eatDate2,
        userId: this.userId,
      };

      //ハンドラに送る・呼び出し
      this.btnCtrl = true;
      this.getRequest(
        "/mealReservationConfirmation/MealConfirmationPDFCreate",
        pdfParams,
        this.$store.getters.getUserToken
      ).then((resp) => {
        //ファイルパスは戻り
        if (resp.success) {
          let streamParams = {
            filePath: resp.result,
          };

          //PDFはダウンロード
          this.getStreamRequest(
            "/mealReservationConfirmation/confirmationPDFGet",
            streamParams,
            this.$store.getters.getUserToken
          )
            .then((res) => {
              const blob = new Blob([res], {
                type: "application/octet-stream;charset=utf-8",
              });

              return fileDownload(blob, "食事確認_" + this.nowDate + ".xlsx");
            })
            .catch(function (error) {
              // console.log(error);
            });
        }
        this.btnCtrl = false;
      });
    },

    getFutureDay() {
      var date1 = new Date(Date.parse(this.eatDate1));
      date1.setDate(date1.getDate() + 30);
      return (
        date1.getFullYear() +
        "-" +
        (date1.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        date1.getDate().toString().padStart(2, "0")
      );
    },
  },
};
</script>

<style lang="scss">
.noPaddingBtm {
  padding-bottom: 0px;
}

.noPadding {
  padding-bottom: 0px;
}

.ryouSelectStyle {
  width: 100%;
  height: 40px;
}

.OfferTitle {
  padding: 0px 55px;
}

.mask {
  box-sizing: border-box;
  border: 1px solid #9e9e9e !important;
  background-color: #bebebe !important;
}

// 2024.10.24 kouta.noborisaka 三井化学（市原工場）:スタイルの定義 Start
.v-event {
  height: auto !important; //要素の高さを可変にする
}
// 2024.10.24 kouta.noborisaka 三井化学（市原工場）:スタイルの定義 End
</style>
